import React, { useState } from 'react';
import { Box, Typography, Link } from '@mui/material';
import ContactDialog from './ContactDialog';

const Footer = () => {
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <Box component="footer" sx={{
      width: '100%',
      bgcolor: 'background.paper',
      color: 'text.secondary',
      py: 2,
      px: 2,
      mt: 4,
      borderTop: '1px solid #222',
      textAlign: 'center',
      fontSize: '0.95rem',
    }}>
      <Typography variant="body2" sx={{ mb: 1 }}>
        &copy; {new Date().getFullYear()} GT Telemetry. All rights reserved.
      </Typography>
      <Box>
        <Link href="/privacy" underline="hover" sx={{ mx: 1 }}>
          Privacy Policy
        </Link>
        |
        <Link href="/terms" underline="hover" sx={{ mx: 1 }}>
          Terms of Service
        </Link>
        |
        <Link component="button" underline="hover" sx={{ mx: 1 }} onClick={() => setContactOpen(true)}>
          Contact
        </Link>
      </Box>
      <ContactDialog open={contactOpen} onClose={() => setContactOpen(false)} />
    </Box>
  );
};

export default Footer;
